import { TextField } from "@mui/material";
import styled from "styled-components"
import { topBarSize, leftBarSize } from "../../../Components/NavBar/styles";
import UploadFileIcon from '@mui/icons-material/UploadFile';

export const Container = styled.div`  
    position: absolute;
    top: calc(${topBarSize});
    left: calc(${leftBarSize});

    width: calc(100% - calc(${leftBarSize} + 1.5rem)) !important;
    height: calc(100% - calc(${topBarSize} + 2rem)) !important;

    padding-top: 1rem;
    padding-left: 1rem;


    z-index: 1;
`;

export const Title = styled.p`
    text-transform: uppercase;
    font-family: 'Roboto';
    font-weight: 900;
    color: rgba(55, 73, 87, 0.7);
    font-size: 2rem;

    z-index: 2;

    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;

    -ms-flex-align: center;
    -webkit-align-items: center;
`;

export const Button = styled.button`
    position: absolute;
    right: 0%;

    height: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;

    text-transform: uppercase;
    font-family: 'Roboto';
    font-weight: 900;
    color: #2E933C;

    background: none;
    border: 2px solid #2E933C;
    border-radius: 20px;

    cursor: pointer;

    &:hover{
        background: rgba(55, 73, 87, 0.1);
        transition-duration: 0.1s;
    }

    &:active{
        background: rgba(55, 73, 87, 0.2);
        transition-duration: 0.1s;
    }

    z-index: 3;
`;

export const Content = styled.div`
    
    width: 95%;
    height: 80%;

    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    border-radius: 10px;
    padding: 5px !important;
    border: 1px solid ${(props) => props.theme.border};
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
`;

export const ContentTitle = styled(Title)`
    color: rgba(55, 73, 87, 1.0);
    font-size: 1.6rem;
    padding-left: 1rem;
    text-transform: none;
    margin-bottom: 1rem;
`;

export const ContentBody = styled.div`
    margin-left: 2rem !important;
`;

export const ContentInput = styled(TextField)`
    margin-top: 0.5rem !important;
`;

export const ContentInputProfilePhotoIcon = styled(UploadFileIcon)`
    position: absolute;

    top: 50%;
    left: 50%;

    transform: translate(-50%, -50%) scale(4);

    color: rgba(255, 255, 255, 0.5);

    opacity: 1;

`;

export const ContentInputProfilePhoto = styled.div`
    border: 1px solid ${(props) => props.theme.border};
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);

    width:  20rem;
    height: 20rem;

    position: absolute;
    top: 50%;
    left: 70%;

    transform: translate(-50%, -50%);

    border-radius: 20px;

    opacity: 0.7;

    z-index: 3;

    &:hover{
        opacity: 1;
        cursor: pointer;
        transition: all 0.2s;
    }

    &:active{
        opacity: 0.5;
    }

    & img{
        width: 100%;
        height: 100%;
        border-radius: 20px;
    }
`;
